import useFlow from '../../flow/state/use-flow'
import useFinalizeOrder from './use-finalize-order'
import useConfig from '../../config/state/use-config'

export default function useFinalizeSingleStepOrder() {
  const flow = useFlow()
  const config = useConfig()
  const finalizeOrder = useFinalizeOrder()

  return async () => {
    if (config.isEmbedded) {
      if (flow.nextStep) {
        flow.goToStep(flow.nextStep.name)
      }
    } else {
      const { transactionId } = await finalizeOrder()
      flow.goNextPostConversion(transactionId)
    }
  }
}
